import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AutoPayout from './AutoPayout';
import messages from '../../../locale/messages';


function action({ store, intl }) {
    const title = intl.formatMessage(messages.manageDriverPayouts);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }

    return {
        title,
        component: (
            <AdminLayout>
                <AutoPayout title={title} />
            </AdminLayout>
        ),
    }
}

export default action;